import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { useRecordContext, useTranslate } from "ra-core";

import type { ZoomMeetingSummary } from "../types";

export const StatusField = () => {
  const record = useRecordContext<ZoomMeetingSummary>();
  const translate = useTranslate();
  if (!record) return null;

  const statusConfig = {
    pending: {
      variant: "outline" as const,
      className:
        "border-orange-300 bg-orange-50 text-orange-700 dark:border-orange-700 dark:bg-orange-950 dark:text-orange-300",
    },
    done: {
      variant: "outline" as const,
      className:
        "border-green-300 bg-green-50 text-green-700 dark:border-green-700 dark:bg-green-950 dark:text-green-300",
    },
  };

  const config = statusConfig[record.status] || statusConfig.pending;

  return (
    <Badge variant={config.variant} className={cn(config.className)}>
      {translate(`resources.zoom_meeting_summaries.status.${record.status}`)}
    </Badge>
  );
};
